import React from 'react';
import { motion } from 'framer-motion';

export default function PrimaryButton({ children, onClick, type = 'button', disabled = false, className = '' }) {
  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={disabled}
      whileHover={!disabled ? { scale: 1.03, y: -2 } : {}}
      whileTap={!disabled ? { scale: 0.97 } : {}}
      transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      className={`relative inline-flex items-center justify-center gap-2 px-8 py-4 text-white font-bold text-base rounded-2xl cursor-pointer select-none ${className}`}
      style={{
        background: disabled
          ? '#94a3b8'
          : 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)',
        boxShadow: disabled
          ? 'none'
          : '0 4px 15px rgba(37, 99, 235, 0.35), 0 1px 3px rgba(0,0,0,0.12)',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      {children}
    </motion.button>
  );
}